import React, {useState, useEffect} from "react"
import {GroupCelebration, GroupCelebrationStatus} from "@irati/types"
import modalStory, {anyStoriesOpen} from "@irati/utils/modalStory"
import History, {historyContext} from "@irati/utils/history"
import GenericModal from "@irati/ui/src/GenericModal"
import RecognitionService from "@irati/recognition/services/Recognition"
import GroupCelebrationQuery, {GroupRecognitionData} from "@irati/recognition/apollo/query/GroupCelebration"
import {Query} from "@irati/utils/services/apollo"
import tracking from "@irati-tracking/recognition/recognition"
import {match as Match} from "react-router-dom"
import ErrorPopup from "../Error"
import SuccessMessage from "../CreateGroupCelebration/SuccessMessage"
import {RecognitionRoutes} from "../../../enums/Routes"
import ViewGroupCelebrationMessage from "./ViewGroupCelebrationMessage"
import InviteCollaboratorsPopup from "./InviteCollaborators"
import PublishErrorModal from "./PublishedErrorModal"
export const INVITE_COLLABORATORS = "INVITE_COLLABORATORS"
export const VIEW_MESSAGE = "VIEW_MESSAGE"
export const SUCCESS_MESSAGE = "SUCCESS_MESSAGE"
export const SUCCESS_MESSAGE_EDITED = "SUCCESS_MESSAGE_EDITED"
const modals = [VIEW_MESSAGE, SUCCESS_MESSAGE, SUCCESS_MESSAGE_EDITED, INVITE_COLLABORATORS]

enum EditType {
  INVITE = "invite"
}

interface Props {
  redirectToFeed?: boolean
  groupCelebration: GroupCelebration
  match: Match
}
const PopupMaps = {
  [EditType.INVITE]: INVITE_COLLABORATORS
}
const GroupCelebrationPopup: React.FC<Props> = (props, context) => {
  const {redirectToFeed, match} = props
  const {uuid: groupCelebrationId, editType} = match.params as {uuid: string; editType: EditType}
  const [show, setShow] = useState(modalStory(modals, PopupMaps[editType] || VIEW_MESSAGE))
  useEffect(() => {
    setShow(modalStory(modals, PopupMaps[editType] || VIEW_MESSAGE, show))
  }, [editType])
  const handleHide = () => {
    if (show.VIEW_MESSAGE) {
      tracking.recognitionCtaClick({
        source: "add_message_modal",
        type: "cancel"
      })
    }
    setShow(modalStory(modals, null))
    History.push(`${RecognitionRoutes.ACCOUNT}/my-group-celebrations`, context, {scrollToTop: false})
  }
  const handleAfterExit = () => {
    if (!anyStoriesOpen(show)) {
      if (redirectToFeed) {
        History.push(`${RecognitionRoutes.ACCOUNT}/my-group-celebrations`, context, {scrollToTop: false})
      }
    }
  }
  const onMessageCreated = () => {
    setShow(modalStory(modals, SUCCESS_MESSAGE, show))
  }
  const onMessageEdited = () => {
    setShow(modalStory(modals, SUCCESS_MESSAGE_EDITED, show))
  }
  const hanldeUnabledCompleteRequestHide = (groupCelebration?: GroupCelebration) => {
    if (groupCelebration) {
      RecognitionService.removeGroupCelebrationFromCache(groupCelebration)
    }
    handleHide()
  }
  const onViewCelebration = () => {
    setShow(modalStory(modals, VIEW_MESSAGE, show))
  }
  return (
    <Query query={GroupCelebrationQuery} variables={{id: groupCelebrationId}} Error={ErrorPopup}>
      {({data}: GroupRecognitionData) => {
        const groupCelebration = data?.groupCelebration
        if (!groupCelebration || groupCelebration.status !== GroupCelebrationStatus.Scheduled) {
          return (
            <PublishErrorModal
              onHide={() => hanldeUnabledCompleteRequestHide(groupCelebration)}
              onConfirm={() => hanldeUnabledCompleteRequestHide(groupCelebration)}
            />
          )
        }
        return (
          <>
            <GenericModal show={show[VIEW_MESSAGE]} onHide={handleHide} onExited={handleAfterExit} hideActions>
              <ViewGroupCelebrationMessage
                groupCelebration={groupCelebration}
                onMessageEdited={onMessageEdited}
                onMessageCreated={onMessageCreated}
              />
            </GenericModal>
            <GenericModal show={show[INVITE_COLLABORATORS]} onHide={handleHide} onExited={handleAfterExit} hideActions>
              <InviteCollaboratorsPopup groupCelebration={groupCelebration} />
            </GenericModal>
            <GenericModal show={show[SUCCESS_MESSAGE] || show[SUCCESS_MESSAGE_EDITED]} small onHide={handleHide} hideActions>
              <SuccessMessage
                scheduledGroupCelebration={groupCelebration!}
                onHide={handleHide}
                onViewCelebration={onViewCelebration}
                isEdit={show[SUCCESS_MESSAGE_EDITED]}
              />
            </GenericModal>
          </>
        )
      }}
    </Query>
  )
}

GroupCelebrationPopup.contextTypes = historyContext

export default GroupCelebrationPopup
